import React, { useState, useEffect } from 'react';
import '../../screens/logging/logging.css';
import axios from 'axios';
import SftGlobalData from '../../library/SftGlobalData';
import Colors from '../../library/Colors';
import 'react-toastify/dist/ReactToastify.css';
import { DataGridPro, useGridApiContext, useGridApiRef } from '@mui/x-data-grid-pro';
import { Box, Button, Chip, Divider, IconButton, InputAdornment, Paper, Stack, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import AssignmentIcon from '@mui/icons-material/Assignment';
import CloseIcon from '@mui/icons-material/Close';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import { styled } from '@mui/system';
import { Modal } from '@mui/material';

const StyledModal = styled(Modal)`
    position: fixed;
    text-align: center;
    z-index: 1300;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    `;

const Backdrop = styled('div')`
    z-index: -1;
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    -webkit-tap-highlight-color: transparent;
    `;

const style = {
    border: '0px solid #000',
    borderRadius: 2,
    p: 3,
    pt: 2,
    width: 'min(1000px, 92vw)',
    maxHeight: '90vh',
    overflowY: 'auto',
    boxShadow: 24,
};

const detailLabelSx = {
    color: 'text.secondary',
    textTransform: 'uppercase',
    letterSpacing: 0.6,
    fontWeight: 600,
    fontSize: '0.7rem',
    display: 'block',
    lineHeight: 1.4,
};

const detailValueSx = {
    fontWeight: 500,
    fontSize: '0.9rem',
    lineHeight: 1.5,
    wordBreak: 'break-word',
};

const renderDetailField = (label, value) => (
    <Box>
        <Typography component="span" sx={detailLabelSx}>{label}</Typography>
        <Typography component="div" sx={detailValueSx}>{value || ' - '}</Typography>
    </Box>
);

function CustomEditComponent(props) {
    const { id, field, value } = props;
    const apiRef = useGridApiContext();
  
    const handleValueChange = (event) => {
        if(props.row.user_id === props.user){
            const newValue = event.target.value; // The new value entered by the user
            apiRef.current.setEditCellValue({ id, field, value: newValue });
        }
    };

    const saveValueChange = () => {
        //console.log("orig", props.orig);
        //console.log("value", value);
        //if(props.orig !== value){
            if (window.confirm("Save changes?") === true) {
                try{
                    let postData = {id: props.row.id, field: props.sql, value: value, user_id: props.row.user_id, sft: props.login?.sft_status};
                    SftGlobalData.post('logging&action=updateLog', postData).then(response => {
                        props.reload();
                    });
                } catch(e){
                    console.error(e);
                }
            } else {
                apiRef.current.setEditCellValue({ id, field, value: props.orig });
            }
        //}
    }

    const handleEnter = (e) => {
        if(e.keyCode === 13){
            saveValueChange();
        }
    }
  
    return <input type="text" value={value} onChange={handleValueChange} onKeyDown={(event)=>{handleEnter(event);}} onBlur={()=>{saveValueChange()}}/>;
  }

const LoggingTable = (props) =>  {
    const [pageSize, setPageSize] = useState(10);
    const [modal, setModal] = useState(false);
    const [selectedLog, setSelectedLog] = useState({});
    const [searchValue, setSearchValue] = useState("");
    const gridColumns = [
        {
            field: 'log_date',
            headerName: props.t('date'),
            headerClassName: 'bold',
            minWidth: 150,
            width: 150,
            align: "left",
            display: "flex",
            renderCell: (params)=>{return <div onClick={() => {setSelectedLog(params.row); setModal(true);}}>{params.row.log_date}</div>}
        },
        {
            field: 'customer',
            headerName: props.t('customer'),
            minWidth: 175,
            width: 225,
            align: "left",
            display: "flex",
        },
        {
            field: 'log_owner',
            headerName: props.t('employee'),
            minWidth: 100,
            width: 110,
            align: "left",
            display: "flex",
        },
        {
            field: 'log_tags',
            headerName: props.t('tags'),
            minWidth: 160,
            align: "left",
            display: "flex",
        },
        {
            field: 'cust_store',
            headerName: props.t('store'),
            minWidth: 175,
            width: 225,
            align: "left",
            display: "flex",
        },
        {
            field: 'log_remark',
            headerName: props.t('problem'),
            width: 500,
            align: "left",
            editable: true,
            display: "flex",
            renderEditCell: (params)=>{return <CustomEditComponent login={props.login} reload={()=>{props.loadLogs();}} orig={params.row.log_remark} sql={"remark"} user={props.userId} {...params}/>}
        },
        {
            field: 'log_time',
            headerName: props.t('duration'),
            minWidth: 75,
            width: 75,
            align: "left",
            display: "flex",
        },
        {
            field: 'caller',
            headerName: props.t('caller'),
            minWidth: 100,
            width: 100,
            align: "left",
            editable: true,
            display: "flex",
            renderEditCell: (params)=>{return <CustomEditComponent login={props.login} reload={()=>{props.loadLogs();}} orig={params.row.caller} sql={"caller"} user={props.userId} {...params}/>}
        },
        {
            field: 'phone',
            headerName: props.t('phone'),
            minWidth: 100,
            width: 100,
            align: "left",
            editable: true,
            display: "flex",
            renderEditCell: (params)=>{return <CustomEditComponent login={props.login} reload={()=>{props.loadLogs();}} orig={params.row.phone} sql={"phone"} user={props.userId} {...params}/>}
        },
        {
            field: 'teamviewer_id',
            headerName: props.t('teamviewer_id'),
            minWidth: 100,
            width: 100,
            align: "left",
            editable: true,
            display: "flex",
            renderEditCell: (params)=>{return <CustomEditComponent login={props.login} reload={()=>{props.loadLogs();}} orig={params.row.teamviewer_id} sql={"teamviewer_id"} user={props.userId} {...params}/>}
        },
        {
            field: 'teamviewer_pass',
            headerName: props.t('teamviewer_pass'),
            minWidth: 100,
            width: 100,
            align: "left",
            editable: true,
            display: "flex",
            renderEditCell: (params)=>{return <CustomEditComponent login={props.login} reload={()=>{props.loadLogs();}} orig={params.row.teamviewer_pass} sql={"teamviewer_ww"} user={props.userId} {...params}/>}
        },
        {
            field: 'priority',
            headerName: props.t('priority'),
            minWidth: 75,
            width: 75,
            align: "left",
            display: "flex",
        },
        {
            field: 'log_solution',
            headerName: props.t('solution'),
            width: 500,
            align: "left",
            editable: true,
            display: "flex",
            renderEditCell: (params)=>{return <CustomEditComponent login={props.login} reload={()=>{props.loadLogs();}} orig={params.row.log_solution} sql={"solution"} user={props.userId} {...params}/>}
        },
        {
            field: 'task',
            headerName: '',
            minWidth: 85,
            width: 85,
            align: "center",
            display: "flex",
            renderCell: (params)=>{return props.userId === params.row.user_id ? <Button onClick={() => {makeTask(params.row.id);}}>{(props.userId === params.row.user_id) && <AssignmentIcon />}</Button> : <div></div>}
        },
      ];
    const apiRef = useGridApiRef();

    const makeTask = (id) => {
        if (window.confirm(props.t('confirm_make_task')) === true) {
            try{
                let postData = {id: id, field: 'completed', value: 0, user_id: props.userId, sft: props.login?.sft_status};
                SftGlobalData.post('logging&action=updateLog', postData).then(response => {
                    props.loadLogs();
                    props.loadTasks();
                });
            } catch(e){
                console.error(e);
            }
        }
    }
    
    useEffect(()=>{
        try{
            apiRef.current.subscribeEvent(
                'columnOrderChange',
                ()=>{visibilityChangedHandler();},
            );
        }catch(ex){
    
        }
    }, [apiRef]);

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    const visibilityChangedHandler = () => {
        let temp = apiRef.current.exportState();
        if(typeof temp.columns.columnVisibilityModel === "undefined"){
            temp.columns.columnVisibilityModel = {};
        }
        try{
            temp.preferencePanel.open = false;
        }catch(e){
    
        }
        try{
            delete temp.pagination;
        }catch(e){
            console.error(e);
        }
        setCookie("initialState", JSON.stringify(temp), 100000);
    }

    function DataGrid() {
        return (
          <div style={props.fill ? { flex: '1 1 0', minHeight: 320, display: 'flex', flexDirection: 'column' } : undefined}>
            <DataGridPro
                apiRef={apiRef}
                className={props.theme}
                initialState={props.initialGrid}
                columns={gridColumns}
                onColumnWidthChange={()=>{visibilityChangedHandler();}}
                onColumnVisibilityModelChange={()=>{visibilityChangedHandler();}}
                onPreferencePanelClose={()=>{visibilityChangedHandler();}}
                rows={props.data.filter(row => (row.customer?.match(new RegExp(searchValue, "i")) || row.log_remark?.match(new RegExp(searchValue, "i")) || row.log_date?.match(new RegExp(searchValue, "i")) || row.log_owner?.match(new RegExp(searchValue, "i")) || row.customer_store?.match(new RegExp(searchValue, "i")) || row.log_tags?.match(new RegExp(searchValue, "i"))))
                .map((row) => {return {
                        id: row.id,
                        customer: row.customer,
                        cust_store_id: row.customer_store_id,
                        cust_store: row.customer_store,
                        log_date: row.log_date,
                        log_tags: row.log_tags.replaceAll("[\"", "").replaceAll("\"", "").slice(0,-1).replaceAll(",", ", "),
                        log_remark: row.log_remark,
                        log_time: row.log_time,
                        log_owner: row.log_owner,
                        log_solution: row.log_solution,
                        caller: row.caller,
                        phone: row.phone,
                        priority: row.priority,
                        teamviewer_id: row.teamviewer_id,
                        teamviewer_pass: row.teamviewer_pass,
                        user_id: row.user_id
                    }
                })}
                rowHeight={38}
                autoHeight={!props.fill}
                style={props.fill ? { flex: 1, minHeight: 0 } : undefined}
                pagination={true}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[10, 20, 30]}
                loading={props.loading}                
                />
          </div>
        );
    }

    // fill: used by the logging overview, where only the grid may scroll (no page scrollbar).
    return (
        <div style={props.fill ? { flex: '1 1 auto', display: 'flex', flexDirection: 'column', width: '100%' } : undefined}>
            <StyledModal
                aria-labelledby="unstyled-modal-title"
                aria-describedby="unstyled-modal-description"
                open={modal}
                onClose={()=>{setModal(false);}}
                BackdropComponent={Backdrop}
                >
                <Box
                    sx={style}
                    className={props.theme + " box_fade-in"}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1 }}>
                        <Stack direction="row" alignItems="center" gap={1}>
                            <AssignmentIcon sx={{ color: Colors.sft_blue }} />
                            <Typography component="h2" className={props.theme} sx={{ m: 0, fontSize: '1.25rem', fontWeight: 600 }}>
                                {props.t('log_details')}
                            </Typography>
                        </Stack>
                        <IconButton onClick={() => setModal(false)} size="small" aria-label="Close">
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <Divider sx={{ mb: 2 }} />

                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                            columnGap: 3,
                            rowGap: 1.75,
                            textAlign: 'left',
                            mb: 2,
                        }}>
                        {renderDetailField(props.t('date'), selectedLog.log_date)}
                        {renderDetailField(props.t('customer'), selectedLog.customer)}
                        {renderDetailField(props.t('store'), selectedLog.cust_store)}
                        {renderDetailField(props.t('user'), selectedLog.log_owner)}
                        {renderDetailField(props.t('duration'), selectedLog.log_time)}
                        <Box>
                            <Typography component="span" sx={detailLabelSx}>{props.t('tags')}</Typography>
                            <Stack direction="row" gap={0.5} flexWrap="wrap" sx={{ mt: 0.5 }}>
                                {(selectedLog.log_tags || '')
                                    .split(',')
                                    .map(t => t.trim())
                                    .filter(Boolean)
                                    .map((t, i) => (
                                        <Chip key={i} label={t} size="small" sx={{ height: 22 }} />
                                    ))}
                                {!(selectedLog.log_tags || '').trim() && (
                                    <Typography component="span" sx={detailValueSx}> - </Typography>
                                )}
                            </Stack>
                        </Box>
                        {selectedLog.caller !== "" && renderDetailField(props.t('caller'), selectedLog.caller)}
                        {selectedLog.phone !== "" && renderDetailField(props.t('phone'), selectedLog.phone)}
                        {selectedLog.teamviewer_id !== "" && renderDetailField(props.t('teamviewer_id'), selectedLog.teamviewer_id)}
                        {selectedLog.teamviewer_pass !== "" && renderDetailField(props.t('teamviewer_pass'), selectedLog.teamviewer_pass)}
                    </Box>

                    <Divider sx={{ mb: 2 }} />

                    <Box sx={{ textAlign: 'left', mb: 2 }}>
                        <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.75 }}>
                            <ReportProblemOutlinedIcon fontSize="small" sx={{ color: '#e09a00' }} />
                            <Typography component="span" sx={{ ...detailLabelSx, fontSize: '0.75rem' }}>
                                {props.t('problem')}
                            </Typography>
                        </Stack>
                        <Paper variant="outlined" sx={{
                            p: 1.5,
                            whiteSpace: 'pre-wrap',
                            overflowWrap: 'anywhere',
                            fontSize: '0.9rem',
                            lineHeight: 1.55,
                            backgroundColor: 'transparent',
                        }}>
                            {selectedLog.log_remark === "" ? " - " : selectedLog.log_remark}
                        </Paper>
                    </Box>

                    <Box sx={{ textAlign: 'left' }}>
                        <Stack direction="row" alignItems="center" gap={1} sx={{ mb: 0.75 }}>
                            <LightbulbOutlinedIcon fontSize="small" sx={{ color: '#2e9e4e' }} />
                            <Typography component="span" sx={{ ...detailLabelSx, fontSize: '0.75rem' }}>
                                {props.t('solution')}
                            </Typography>
                        </Stack>
                        <Paper variant="outlined" sx={{
                            p: 1.5,
                            whiteSpace: 'pre-wrap',
                            overflowWrap: 'anywhere',
                            fontSize: '0.9rem',
                            lineHeight: 1.55,
                            backgroundColor: 'transparent',
                        }}>
                            {selectedLog.log_solution === "" ? " - " : selectedLog.log_solution}
                        </Paper>
                    </Box>
                </Box>
            </StyledModal>
            <div className='log__container_options'>
                <TextField
                id="input-with-icon-textfield"
                autoComplete="off" 
                className={props.theme+ '_accent ' + (props.screenWidth > 900 ? 'margin_right__10px' : '')}
                sx={{ borderRadius: 3, marginTop: 0 }}
                size={'small'}
                fullWidth
                type="search"
                placeholder={props.t('search')}
                onChange={(e) => setSearchValue(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{color: Colors.sft_blue}} />
                    </InputAdornment>
                  ),
                }}
               />
                {props.screenWidth > 900 && <Button
                    sx={{ borderRadius: 3, border: '2px solid '+Colors.sft_blue, color: Colors.sft_blue}}
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={() => {props.openModal();}}
                  >
                    {props.t("add")}
                </Button>}                
            </div>            
            {props.screenWidth <= 900 && <Button
                    sx={{ borderRadius: 3, border: '2px solid '+Colors.sft_blue, color: Colors.sft_blue, width: '100%', marginBottom: '10px'}}
                    variant="outlined"
                    startIcon={<AddIcon />}
                    onClick={() => {props.openModal();}}
                  >
                    {props.t("add")}
                </Button>} 

            
            {DataGrid()}
        </div>
    );
}

export default LoggingTable;
